// extracted by mini-css-extract-plugin
export default {"titleRewritter":"src-pages-ProductReview-ProductReviewDetail-ReviewCard-css-module__titleRewritter--xc1K4"};